<div class="widget__wrap">
    <div class="widget"
         id="news-widget">
        <h2 class="widget__header">
            <span class="widget__header__title"><i class="widget__header__icon ico-angle-down"></i>Sponzorujeme</span>
            <span class="widget__header__tools"><a class="cta cta--small cta--green"
                   [routerLink]="['sponsored/add']"><span class="cta__light">Přidat</span> sponzorovaného <i
                       class="ico-plus"></i></a>
            </span>
        </h2>
        <div class="widget__content">
            <swb-sponsored-list></swb-sponsored-list>
        </div>
    </div>
</div>